import type { CreateUsageParams, UpdateUsageParams } from 'types';

export default (values: CreateUsageParams | UpdateUsageParams) => {
  const validationErrors = {};
  if (!values.name) {
    validationErrors.name = 'Usage name cannot be blank';
  }
  return validationErrors;
};
